module.exports = __webpack_public_path__ + "img/racha-frame-dark.41e5aeaf.svg";